module.exports = __webpack_public_path__ + "img/inter11.45757be2.jpg";